import { track as plausibleTrack } from '@plausible-analytics/tracker'

// Thin wrapper around @plausible-analytics/tracker's track().
//
// In production this is a direct delegation. In system specs, the test
// installs `window.__plausible_track_seam` before any user interaction;
// when present, calls go through the seam (which records them and
// fires opts.callback synchronously) and the npm package is never hit.
//
// See specs/009-marketing-monorepo/q-roi-rechner-spec.md decision q-22.
export function track(event, opts) {
  if (typeof window !== 'undefined' && typeof window.__plausible_track_seam === 'function') {
    return window.__plausible_track_seam(event, opts)
  }
  return plausibleTrack(event, opts)
}
